<template>
  <span class="badge session-status" :class="props.status">{{
    formatStatus(props.status ?? 'unknown')
  }}</span>
</template>

<script setup lang="ts">
import type { SessionStatus } from '@/stores/ws.ts'

export type SessionStatusOrUnknown = SessionStatus | 'unknown'

const props = withDefaults(
  defineProps<{
    status?: SessionStatusOrUnknown
  }>(),
  {
    status: 'unknown',
  },
)

const STATUS_MAP: Record<SessionStatusOrUnknown, string> = {
  created: 'Created',
  ready: 'Ready',
  failsafe: 'Failsafe',
  countdown: 'Countdown',
  paused: 'Paused',
  success: 'Success',
  fail: 'Failed',
  aborted: 'Aborted',
  closed: 'Closed',
  unknown: 'Unknown',
}

function formatStatus(status: SessionStatusOrUnknown): string {
  return STATUS_MAP[status || 'unknown'] ?? status
}
</script>

<style scoped lang="scss">
.badge {
  // padding: .15rem .5rem;
  // border-radius: .4rem;
  // border: 1px solid var(--color-border);

  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;

  &.success {
    background: var(--status-success-bg);
    color: var(--status-success);
  }

  &.fail {
    background: var(--status-fail-bg);
    color: var(--status-fail);
  }

  &.aborted {
    background: var(--status-aborted-bg);
    color: var(--status-aborted);
  }

  &.closed {
    background: var(--status-closed-bg);
    color: var(--status-closed);
  }

  &.ready {
    background: var(--status-ready-bg);
    color: var(--status-ready);
  }

  &.failsafe {
    background: var(--status-failsafe-bg);
    color: var(--status-failsafe);
  }

  &.created {
    background: var(--status-created-bg);
    color: var(--status-created);
  }

  &.countdown {
    background: var(--status-countdown-bg);
    color: var(--status-countdown);
  }

  &.paused {
    background: var(--status-paused-bg);
    color: var(--status-paused);
  }
}
</style>
